import React, { useCallback, useState } from "react";
import Api from "../../../utils/api.utils";
import { apiURL } from "../../../utils/constant";
import { useDispatch, useSelector } from "react-redux";
import { getMobileNo, getPatientData } from "../../selector/auth.selector";
import {
  hidePageLoader,
  showPageLoader,
} from "../../reducer/pageLoader.reducer";
import { setMobileNo, setPatientData } from "../../reducer/auth.reducer";
const usePatientDetails = () => {
  // const [SubjectDetails, setSubjectDetails] = useState([]);
  const SubjectDetails = useSelector(getPatientData);
  const mobileNo = useSelector(getMobileNo);

  const dispatch = useDispatch();
  const fetchPatientDetails = useCallback(async () => {
    try {
      dispatch(showPageLoader());
      const { data } = await Api.get({
        url: apiURL.subjectDetailsByMobileNo(),
        params: {
          MobileNo: mobileNo,
        },
      });

      dispatch(setPatientData([]));
      dispatch(hidePageLoader());
    } catch (error) {
      dispatch(hidePageLoader());
      console.log("error==>", error);
    }
  }, []);
  return { SubjectDetails, fetchPatientDetails };
};

export default usePatientDetails;
